import { useContext, useEffect, useState } from "react";
import { RequestContext } from "../../context/request.context";
import { Box, Typography } from "@mui/material";
import numberFormat from "../globalFunction/prettierNumber";

const Stock = ({ id }) => {
  const { request } = useContext(RequestContext);
  // const [stock, setStock] = useState([]);
  const [productInShopList, setProductInShopList] = useState([]);

  useEffect(() => {
    request(`/product/${id}`, "GET").then((res) => {
      // setStock(res);
      setProductInShopList(res.productInShopList);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const total = productInShopList.reduce((acc, item) => {
    return acc + item.amount;
  }, 0);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Typography variant="caption" textAlign={"center"}>
        {numberFormat(total)}
      </Typography>
    </Box>
  );
};

export default Stock;
